<template>
    <painel-component :title="'Usuário'">
        <div class="aux mb-4">
            <div class="avatar-form">
                <img v-if="me.photo" :src="imagePreview" class="avatar__image" alt="">
                <img v-else src="@/assets/avatar.png" class="avatar__image" alt="">
            </div>
            <p>{{ me.fullName }}</p>
        </div>

        <form autocomplete="off">
            <row-component>
                <row-col-component :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'">
                    <label>Foto:</label>
                    <input type="file" name="file" id="formFile" @change="onFileChange">
                    <label for="formFile" class="labelFile">
                        <span>{{ this.namePhoto }}</span>
                        <span><i class="icon photo"></i></span>
                    </label>
                </row-col-component>
            </row-component>

            <buttons-default :items="buttonDefault" @click="goHome"/>

        </form>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import ButtonsDefault from "@/components/buttons/ButtonsDefault";
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "UserUpdatePhoto",
    components: {
        PainelComponent,
        RowComponent,
        RowColComponent,
        ButtonsDefault
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Usuário')
    },

    data() {
        return {

            imagePreview: "",

            buttonDefault: {
                title: "Voltar",
                name: "Voltar",
                icon: "reply"
            },

            itensTwo: {
                route: "/",
                icon: "reply all",
                name: 'Voltar'
            },

            formDate: {
                photo: '',
            },

            namePhoto: '',
        }
    },
    methods: {
        submit() {
            if (!this.sendForm) {
                this.sendForm = true;
                this.$store.dispatch('updateUserPhoto', this.formDate)
                    .then((r) => {
                        this.sendForm = false
                        this.$store.dispatch('UpdateLinkPhoto', r.data[0].photo)
                        toast.success('Foto atualizada com sucesso', {timeout: 2000});
                    }).catch((r) => {
                    this.sendForm = false
                    this.errors = r.response.data.errors;
                    toast.error("Erro ao atualizar foto", {timeout: 2000});
                })
            }
        },
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files
            if (!files.length)
                return

            this.formDate.photo = files[0]
            this.namePhoto = this.formDate.photo.name
            if (files[0].type.indexOf('image') === 0)
                this.previewImage(files[0])
            this.submit()
        },

        previewImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.imagePreview = e.target.result
            }
            reader.readAsDataURL(file)
        },

        photoPreviewTimer() {
            this.imagePreview = this.me.photo
        },

        goHome() {
            this.$router.push({name: 'condominium'})
        }

    },

    computed: {
        me() {
            return this.$store.state.auth.me
        },
    },

    beforeMount() {
        setTimeout(() => this.photoPreviewTimer(), 1000);
    },

}
</script>

<style scoped>
input[type="file"] {
    display: none;
}

.labelFile {
    height: 40px;
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    color: #000;
    border: 1px solid #ddd;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    cursor: pointer;
}

.labelFile span:nth-child(2) {
    color: #fff;
    height: 40px;
    width: 40px;
    line-height: 40px;
    text-align: center;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: #d67c1c;
    cursor: pointer;
}
</style>